import React, { useState } from "react";
import {
  Dimensions,
  FlatList,
  Image,
  Modal,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { VehicleList } from "../../Constants/Data";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import useAppNavigation from "../../Routes/useAppNavigation";
// import { useTranslation } from "react-i18next";

const { width, height } = Dimensions.get("window");
const Orders = () => {
  const navigation = useAppNavigation();
  const [DotModal, setDotModal] = useState(false);
  const [select, setSelected] = useState(0);
  const [activeIndex, setActiveIndex] = useState(1);
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const handleTextPress = (index) => {
    setActiveIndex(index);
  };
  return (
    <SafeAreaView style={styles.MainView}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 1 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <Text
            style={{
              color: AppColors.brown1,
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              marginLeft: 20,
            }}
          >
            {t("common:translation.Orders")}{" "}
          </Text>
        </View>

        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Image
            source={AppImages.Bellnoti}
            style={{ width: 16, height: 20 }}
            resizeMode="contain"
          />
          <TouchableOpacity
            onPress={() => navigation.navigate("ManualRouting")}
            style={[
              {
                borderColor: AppColors.brown,
                borderRadius: 10,
                borderWidth: 1,
                paddingHorizontal: 10,
                paddingVertical: 3,
                marginLeft: 20,
                //  height:32
              },
            ]}
          >
            <Text
              style={[
                {
                  color: "#9C4900",
                  fontFamily: AppFonts.OverpassRegular,
                  fontSize: 14,
                  letterSpacing: 0.56,
                  //lineHeight: 24,
                  //  marginLeft: 20,
                },
              ]}
            >
              {t("common:translation.Manual Routing")}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          marginTop: 20,
          backgroundColor: AppColors.white,
        }}
      >
        <View
          style={{
            flexDirection: "row",

            alignItems: "center",

            marginHorizontal: 20,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",

              marginTop: 20,
              // width: "100%",
              // height: height * 0.07,
              borderRadius: 10,
              borderColor: AppColors.sandal,
              //  height: height * 0.07,
              borderWidth: 1,
              // height: 45,
              flex: 1,
            }}
          >
            <TextInput
              placeholder={t(
                "common:translation.Search Order Number, Customer Name...."
              )}
              placeholderTextColor="#ACACAC80"
              style={{
                fontSize: 12,
                // alignItems: "center",
                fontFamily: AppFonts.OverpassMedium,
                width: "90%",
                paddingLeft: 13,
              }}
            />
            <View style={styles.vee}>
              <Image
                source={AppImages.search}
                style={{
                  width: 17,
                  height: 17,
                  resizeMode: "contain",
                  marginRight: 11,
                }}
                resizeMode="contain"
              />
            </View>
          </View>

          {/* <TouchableOpacity style={styles.too}></TouchableOpacity> */}
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 13,
              marginTop: 10,
            }}
          >
            <Image
              source={AppImages.Import}
              style={{ height: 20, width: 22 }}
              resizeMode="contain"
            />

            <Image
              source={AppImages.Shareit}
              style={{ height: 25, width: 23, marginLeft: 16 }}
              resizeMode="contain"
            />
          </View>
        </View>
        <View style={{ marginTop: 20 }} />
        <FlatList
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          ListFooterComponent={() => (
            <View style={{ padding: 60 }}>
              <View
                style={{
                  height: 20,
                  backgroundColor: AppColors.sandal,
                  shadowColor: AppColors.brown,
                  shadowOffset: { width: 10, height: 1 },
                  shadowOpacity: 10,
                  shadowRadius: 10,
                  elevation: -10,
                }}
              ></View>
            </View>
          )}
          data={VehicleList}
          renderItem={({ item }) => (
            <TouchableOpacity onPress={() => navigation.navigate("ViewOrder")}>
              <View
                style={{
                  backgroundColor: "#F6EFE9",
                  marginHorizontal: 20,
                  //paddingHorizontal: 20,
                  paddingVertical: 14,
                  borderRadius: 10,
                  marginBottom: 20,
                }}
              >
                <View
                  style={[
                    styles.FlatImg,
                    { borderBottomWidth: 1, borderBottomColor: "#9C49001A" },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "row",
                      marginLeft: 20,
                      paddingBottom: 14,
                      alignItems: "center",
                    }}
                  >
                    <Image
                      source={AppImages.Boycircle}
                      style={{ width: 50, height: 46 }}
                      resizeMode="contain"
                    />
                    <View style={{ marginLeft: 29 }}>
                      <Text
                        style={{
                          color: AppColors.dualbrown,
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                        }}
                      >
                        {t("common:translation.Customer Name")}
                      </Text>
                      <Text
                        style={{
                          color: "#8F4300",
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                          marginTop: 3,
                        }}
                      >
                        Jhon Doe
                      </Text>
                    </View>
                  </View>
                  {/* <TouchableOpacity onPress={() => setDotModal(true)}>
                  <Image
                    source={item.Dot}
                    style={{
                      width: 22,
                      height: 22,
                      alignItems: "center",
                      marginRight: 23,
                    }}
                    resizeMode="contain"
                  />
                </TouchableOpacity> */}
                </View>
                <View style={{ marginHorizontal: 20 }}>
                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: "#8F430080",
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Order Number")}
                    </Text>
                    <Text
                      style={{
                        color: "#8F430080",
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                      }}
                    >
                      {t("common:translation.Amount")}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: "#8F4300",
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                        // marginTop: 3,
                        width: "50%",
                      }}
                    >
                      10023{" "}
                    </Text>
                    <Text
                      style={{
                        color: "#8F4300",
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                        // marginTop: 3,
                      }}
                    >
                      5000{" "}
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={{
                        color: "#8F430080",
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Order Status")}
                    </Text>
                    <Text
                      style={{
                        color: "#8F430080",
                        fontSize: 12,
                        fontFamily: AppFonts.OverpassRegular,
                        width: "50%",
                      }}
                    >
                      {t("common:translation.Order Date & Time")}
                    </Text>
                  </View>
                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 5,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                        // marginTop: 3,
                        width: "50%",
                      }}
                    >
                      Delivered{" "}
                    </Text>
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontSize: 14,
                        fontFamily: AppFonts.OverpassSemiBold,
                        // marginTop: 3,
                        width: "50%",
                      }}
                    >
                      08-02-2023, 4:30pm{" "}
                    </Text>
                  </View>
                </View>
              </View>
            </TouchableOpacity>
          )}
        />
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
          <View
            style={{ backgroundColor: "#766C8E", flex: 1, opacity: 0.55 }}
          ></View>
        </TouchableWithoutFeedback>
        <View
          style={{
            width: "100%",
            backgroundColor: "white",

            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
            position: "absolute",
            bottom: 0,
            padding: 20,
          }}
        >
          <TouchableOpacity
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Image
              source={AppImages.LineBar}
              style={{ width: 40, height: 2.5 }}
            />
          </TouchableOpacity>
          <TouchableWithoutFeedback onPress={() => handleTextPress(1)}>
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                  //   flexDirection:"row"
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 1 && styles.activeText]}
              >
                View{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback onPress={() => handleTextPress(2)}>
            <View
              style={
                {
                  //  alignItems: "center",
                  //  justifyContent: "center",
                  //  marginLeft: 10,
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 2 && styles.activeText]}
              >
                Edit{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback onPress={() => handleTextPress(3)}>
            <View
              style={
                {
                  // alignItems: "center",
                  // justifyContent: "center",
                  //  marginLeft: 10,
                }
              }
            >
              <Text
                style={[styles.text, activeIndex === 3 && styles.activeText]}
              >
                Delete{" "}
              </Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </Modal>
    </SafeAreaView>
  );
};

export default Orders;
const styles = StyleSheet.create({
  MainView: { backgroundColor: AppColors.sandal, flex: 1 },
  SecMain: { backgroundColor: AppColors.white, marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 20,
    width: "100%",
    height: height * 0.07,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "90%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginTop: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    margin: 10,
    marginLeft: 20,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { marginLeft: 20 },
  FlatTxtSec: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  LineBars: {
    width: "100%",
    right: 20,
    // position: 'absolute',
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
  },
  CopyText: {
    fontSize: 14,
    marginTop: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
    fontWeight: "700",
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    // fontWeight: '700',
  },
  Row: { flexDirection: "row", flex: 1, alignItems: "center" },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
